import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useAuthentication } from '../contexts/Authentication';
import { Link, NavLink } from 'react-router-dom';
import React from 'react';
import { withTranslation } from 'react-i18next';

const AuthenticatedUserNavBar = ({ t, onSignOut = () => { } }) => {

  const authentication = useAuthentication();

  if (!authentication.isAuthenticated()) {
    return '';
  }

  const handleSignOut = (e) => {
    e.preventDefault();
    onSignOut();
  };

  const logoutOrStopActingOnBehalOf = <>
    {!authentication.isSystemAdmin() ?
      <Nav.Item as="li">
        <Link to='' className="nav-link" onClick={handleSignOut}>{t('common:actions.logout')}<span className="sr-only">(current)</span></Link>
      </Nav.Item> :
      <Nav.Item as="li">
        <a className="nav-link" href={authentication.currentUser.actingOnBehalfOf.returnBackTo} >{t('common:actions.backToAdmin')}<span className="sr-only">(current)</span></a>
      </Nav.Item>
    }
  </>;

  const voucherManagerOrSystemAdmin =authentication.currentUser.voucherManager || authentication.currentUser.systemAdmin;
  const userManagerOrSystemAdmin = authentication.currentUser.userManager || authentication.currentUser.systemAdmin;

  return <Nav as="ul" className="ms-auto">
    <NavDropdown as="li" title={t('settings')}>
      <NavDropdown.Item as={Link} to="/organisationManagement" disabled={true}>{t('organisationManagement')}</NavDropdown.Item>
      { userManagerOrSystemAdmin ? <NavDropdown.Item as={Link} to="/userManagement">{t('userManagement:title')}</NavDropdown.Item> : null }
    </NavDropdown>

    { logoutOrStopActingOnBehalOf }
  </Nav>;
};

export default withTranslation()(AuthenticatedUserNavBar);
